"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagSM = function FlagSM(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6,12.18H-193V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-193,12.18H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06H-185.94A7.06,7.06,0,0,1-193,139.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.46,69.77c-1.2-.06-29.44-1.5-43.61-20.92C-39.41,37.54-41.06,22.49-36,4.12l2,.56c-4.84,17.71-3.3,32.16,4.56,42.93,13.56,18.6,41.72,20,42,20.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#b46446"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-36.07-4a12.26,12.26,0,0,0,.54,10.31A12.23,12.23,0,0,0-28.23-1a12.23,12.23,0,0,0-.54-10.3A12.22,12.22,0,0,0-36.07-4Zm0,0",
    transform: "translate(194 123)",
    fill: "#41aa5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-18.38,46.12a11.05,11.05,0,0,0-.81,9.29A11.11,11.11,0,0,0-13.36,62a11,11,0,0,0-8.74-.56,11,11,0,0,0-6.81,6.36,11,11,0,0,0,9.28.8,11,11,0,0,0,6.82-6.36A11.06,11.06,0,0,0-12,52.93a11.05,11.05,0,0,0-6.36-6.81Zm0,0",
    transform: "translate(194 123)",
    fill: "#41aa5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-24.43,36.86a11.11,11.11,0,0,0-4.21,8.32,11.08,11.08,0,0,0,3,8.25,11.11,11.11,0,0,0-7.91-3.79A11.1,11.1,0,0,0-42.27,53a11,11,0,0,0,8.32,4.21,11,11,0,0,0,8.7-3.36,11.05,11.05,0,0,0,4.18-8.29,11,11,0,0,0-3.36-8.7Zm0,0",
    transform: "translate(194 123)",
    fill: "#41aa5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-27,26.43a11,11,0,0,0-7,6.11,11.1,11.1,0,0,0-.36,8.76,11.05,11.05,0,0,0-5.89-6.48,11.07,11.07,0,0,0-9.32-.18,11,11,0,0,0,6.11,7,11,11,0,0,0,9.32.17h0a11,11,0,0,0,7-6.1A11,11,0,0,0-27,26.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#41aa5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-25.56,16.08a11,11,0,0,0-8.73,3.27,11.12,11.12,0,0,0-3.38,8.09,11.09,11.09,0,0,0-3.27-8.13,11,11,0,0,0-8.67-3.41,11,11,0,0,0,3.27,8.72A11,11,0,0,0-37.66,28h0A11,11,0,0,0-29,24.75a11,11,0,0,0,3.41-8.67Zm0,0",
    transform: "translate(194 123)",
    fill: "#41aa5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-23.46,6.22A11.08,11.08,0,0,0-32.61,8a11.1,11.1,0,0,0-4.68,7.41,11.08,11.08,0,0,0-1.87-8.56,11,11,0,0,0-8-4.79,11.06,11.06,0,0,0,1.79,9.14,11,11,0,0,0,8,4.8h0a11,11,0,0,0,9.12-1.8,11,11,0,0,0,4.8-8Zm0,0",
    transform: "translate(194 123)",
    fill: "#41aa5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-20.44,60.59a2.19,2.19,0,0,1-2.19,2.18,2.19,2.19,0,0,1-2.18-2.18,2.19,2.19,0,0,1,2.18-2.19,2.19,2.19,0,0,1,2.19,2.19Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-10.4,61.81A2.19,2.19,0,0,1-12.59,64a2.19,2.19,0,0,1-2.18-2.19,2.18,2.18,0,0,1,2.18-2.18,2.18,2.18,0,0,1,2.19,2.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-26.21,44.07a2.18,2.18,0,0,1-2.18,2.19,2.19,2.19,0,0,1-2.19-2.19,2.19,2.19,0,0,1,2.19-2.18,2.18,2.18,0,0,1,2.18,2.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-40.1,27.64a2.19,2.19,0,0,1-2.19,2.19,2.18,2.18,0,0,1-2.18-2.19,2.18,2.18,0,0,1,2.18-2.18,2.19,2.19,0,0,1,2.19,2.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-30.4,16.52a2.19,2.19,0,0,1-2.19,2.19,2.19,2.19,0,0,1-2.18-2.19,2.19,2.19,0,0,1,2.18-2.18,2.19,2.19,0,0,1,2.19,2.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-34.08,5.12A2.19,2.19,0,0,1-36.27,7.3a2.19,2.19,0,0,1-2.18-2.18,2.19,2.19,0,0,1,2.18-2.19,2.19,2.19,0,0,1,2.19,2.19Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.55,69.77l-.1-2.1c.29,0,28.44-1.46,42-20.07C62.32,36.84,63.85,22.39,59,4.68l2-.56c5,18.37,3.36,33.42-4.9,44.73C42,68.27,13.74,69.71,12.55,69.77Zm0,0",
    transform: "translate(194 123)",
    fill: "#b46446"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M61.07-4a12.26,12.26,0,0,1-.54,10.31A12.22,12.22,0,0,1,53.24-1a12.2,12.2,0,0,1,.53-10.3A12.22,12.22,0,0,1,61.07-4Zm0,0",
    transform: "translate(194 123)",
    fill: "#41aa5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M43.38,46.12a11.4,11.4,0,0,1-5,15.83,11.41,11.41,0,0,1,15.56,5.8,11.47,11.47,0,0,1-16.1-5.56,11.46,11.46,0,0,1,5.57-16.07Zm0,0",
    transform: "translate(194 123)",
    fill: "#41aa5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M49.43,36.86a11.43,11.43,0,0,1,1.24,16.57A11.4,11.4,0,0,1,67.27,53a11.47,11.47,0,0,1-17,.85h0a11.46,11.46,0,0,1-.83-17Zm0,0",
    transform: "translate(194 123)",
    fill: "#41aa5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M52,26.43a11.41,11.41,0,0,1,7.4,14.87,11.43,11.43,0,0,1,15.21-6.66,11.46,11.46,0,0,1-15.43,7.21h0a11.05,11.05,0,0,1-7-6.1A11.06,11.06,0,0,1,52,26.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#41aa5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50.56,16.08a11,11,0,0,1,8.73,3.27,11.17,11.17,0,0,1,3.39,8.09A11.41,11.41,0,0,1,74.62,15.9a11.06,11.06,0,0,1-3.28,8.72A11,11,0,0,1,62.66,28h0A11,11,0,0,1,54,24.75a11,11,0,0,1-3.41-8.67Zm0,0",
    transform: "translate(194 123)",
    fill: "#41aa5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M48.46,6.22a11.42,11.42,0,0,1,13.83,9.2,11.08,11.08,0,0,1,1.87-8.56,11,11,0,0,1,8-4.79,11,11,0,0,1-1.79,9.14,11,11,0,0,1-8,4.8h0a11,11,0,0,1-9.12-1.8,11.06,11.06,0,0,1-4.8-8Zm0,0",
    transform: "translate(194 123)",
    fill: "#41aa5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M49.82,60.59a2.19,2.19,0,1,1-2.19-2.19,2.19,2.19,0,0,1,2.19,2.19Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M39.76,61.81a2.19,2.19,0,1,1-2.19-2.18,2.19,2.19,0,0,1,2.19,2.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M55.58,44.07a2.19,2.19,0,1,1-2.19-2.18,2.19,2.19,0,0,1,2.19,2.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M69.47,27.64a2.19,2.19,0,1,1-2.18-2.18,2.18,2.18,0,0,1,2.18,2.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M59.78,16.52a2.19,2.19,0,1,1-2.19-2.18,2.19,2.19,0,0,1,2.19,2.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M63.46,5.12a2.19,2.19,0,1,1-2.19-2.19,2.19,2.19,0,0,1,2.19,2.19Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.8-3.63H-.26A14.13,14.13,0,0,0-14.39,10.5V32.57A14.13,14.13,0,0,0-.26,46.7H24.8A14.13,14.13,0,0,0,38.92,32.57V10.5A14.13,14.13,0,0,0,24.8-3.63Zm0,0",
    transform: "translate(194 123)",
    fill: "#8cd7ff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.4,15.59v2.79H13.6V15.59H11.45v2.79H8.66V15.59H6.91v5.59L8.31,23v20.6H16.7V23l1.39-1.77V15.59Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.91,6.73c1.38-.67,1.75,2.16,1.75,2.16a3.2,3.2,0,0,0,1.45-5C15.18,2.42,11.45,1.84,9.88,5s2.68,9.38,2.68,9.38c.23-1.93-1.46-6.77.35-7.64Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M30.78,20.8v2.8H28V20.8H25.83v2.8H23V20.8H21.28v5.59l1.4,1.77v20.6h8.39V28.16l1.4-1.77V20.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M27.28,11.94C28.66,11.28,29,14.1,29,14.1a3.21,3.21,0,0,0,1.46-4.95c-.94-1.51-4.66-2.1-6.24,1s2.68,9.38,2.68,9.38c.24-1.92-1.45-6.76.35-7.64Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2,20.8v2.8H-.77V20.8H-2.92v2.8h-2.8V20.8H-7.46v5.59l1.39,1.77v20.6H2.32V28.16l1.4-1.77V20.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-1.46,11.94C-.08,11.28.28,14.1.28,14.1A3.21,3.21,0,0,0,1.74,9.15c-.94-1.51-4.66-2.1-6.24,1s2.69,9.38,2.69,9.38c.23-1.92-1.46-6.76.35-7.64Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M35.44,45a13.49,13.49,0,0,0-12.72.21,13.86,13.86,0,0,0-20.44,0,13.85,13.85,0,0,0-6.56-1.7A13.89,13.89,0,0,0-10.44,45c4,7.32,11.63,19.15,22.94,23.67,11.3-4.52,19-16.35,22.94-23.67Zm0,0",
    transform: "translate(194 123)",
    fill: "#6ec86e"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.37-48.66l.13-.07a.5.5,0,0,0-.13.07Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5-48.73l.13.07a.5.5,0,0,0-.13-.07Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M39.33-36.75c-.79-4.55-6.64-5.34-13.37-5.77s-9.62-4.28-9.62-4.28H8.66S5.77-43-1-42.52s-12.58,1.22-13.36,5.77,5,11.71,5,11.71l5.06-4.11s-6.2-5.94-3.14-8.13S4.4-37.94,8.32-43.12a7.46,7.46,0,0,0,.57,4.06,16.67,16.67,0,0,1,.81,7.11h5.6a16.67,16.67,0,0,1,.81-7.11,7.56,7.56,0,0,0,.57-4.06c3.92,5.18,12.72,3.69,15.74,5.84s-3.14,8.13-3.14,8.13L34.34-25s5.77-7.17,5-11.71Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.35-62.53H13.9v-1.58a1.4,1.4,0,0,0-1.4-1.39,1.4,1.4,0,0,0-1.4,1.39v1.58H9.59a1.39,1.39,0,0,0-1.4,1.4,1.4,1.4,0,0,0,1.4,1.4H11.1v4a1.4,1.4,0,0,0,1.4,1.4,1.4,1.4,0,0,0,1.4-1.4v-4h1.45a1.4,1.4,0,0,0,1.4-1.4,1.39,1.39,0,0,0-1.4-1.4Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.29-54.32a2.79,2.79,0,0,1-2.79,2.8,2.8,2.8,0,0,1-2.8-2.8,2.79,2.79,0,0,1,2.8-2.79,2.79,2.79,0,0,1,2.79,2.79Zm0,0",
    transform: "translate(194 123)",
    fill: "#fff0e1"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-7.54,2A8.72,8.72,0,0,0-3.75,3C.88,3,3.15.39,3.15-4.25s-2.8-8.13-7.43-8.13a11.28,11.28,0,0,0-1.36.14l-.53.1c-4.45.85-15.46,5-17.68,24.93C-26.95,40.72-4.28,65.92,12.5,71.51v-2.8S-27.11,38.42-7.54,2Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffc75a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-4.28-9.58,12.5-4-4.28,1.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffc75a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M29.28,1.6,12.5-4l16.78-5.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-21.07,13.1c2-18,11.45-21.74,15.52-22.51l.34-.06c.51-.08.86-.1,1-.11A5,5,0,0,1,.85-4.45C.85-1.37-1-.2-2.76-.14c0,0,1.46-3-1.52-3.85A3.56,3.56,0,0,0-8.59,0,4.56,4.56,0,0,0-4.28,4C.35,4,4.11.64,4.11-4a8.39,8.39,0,0,0-8.39-8.39,11.28,11.28,0,0,0-1.36.14l-.53.09c-4.45.86-15.46,5-17.68,24.94C-26.95,40.72-4.28,65.92,12.5,71.51v-2.8a91.22,91.22,0,0,1-10-5.86C-10.06,53.94-23.34,33.49-21.07,13.1Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M32.54,2a8.72,8.72,0,0,1-3.79,1c-4.63,0-6.9-2.61-6.9-7.25s2.79-8.13,7.43-8.13a11.28,11.28,0,0,1,1.36.14l.53.1c4.45.85,15.46,5,17.68,24.93C52,40.72,29.28,65.92,12.5,71.51v-2.8S52.11,38.42,32.54,2Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffc75a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M29.28-9.58,12.5-4,29.28,1.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffc75a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M46.07,13.1c-2-18-11.45-21.74-15.52-22.51l-.34-.06c-.51-.08-.86-.1-1-.11a5,5,0,0,0-5.09,5.13C24.15-1.37,26-.2,27.76-.14c0,0-1.46-3,1.52-3.85a3.56,3.56,0,0,1,4.31,4,4.55,4.55,0,0,1-4.31,4C24.64,4,20.89.64,20.89-4a8.39,8.39,0,0,1,8.39-8.39,11.28,11.28,0,0,1,1.36.14l.53.09c4.45.86,15.46,5,17.68,24.94C52,40.72,29.28,65.92,12.5,71.51v-2.8a91.22,91.22,0,0,0,10-5.86C35.05,53.94,48.34,33.49,46.07,13.1Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.29-4a2.79,2.79,0,0,1-2.79,2.8A2.8,2.8,0,0,1,9.7-4a2.8,2.8,0,0,1,2.8-2.8A2.8,2.8,0,0,1,15.29-4Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M32.47-26.44c.74-1.93-.27-4.5-.27-4.5a6.28,6.28,0,0,0-4.36,1.79,9.54,9.54,0,0,0-.79-4.42c-3.32.4-4.41,2.37-4.41,2.37a6.62,6.62,0,0,0-2.36-5.12,6.2,6.2,0,0,0-3.76,4c-.44-3.58-4-5.24-4-5.24s-3.58,1.66-4,5.24a6.18,6.18,0,0,0-3.75-4A6.61,6.61,0,0,0,2.36-31.2s-1.09-2-4.41-2.37a9.4,9.4,0,0,0-.79,4.42A6.25,6.25,0,0,0-7.2-30.94s-1,2.57-.26,4.5A7.43,7.43,0,0,0-12.8-26s4.41,1.71,5.88,3.81H31.93C33.39-24.26,37.8-26,37.8-26a7.4,7.4,0,0,0-5.33-.47Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffc75a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M31.93-22.16C31.93-20.9,29-17,29-17A148.1,148.1,0,0,1,12.5-15.69,144.54,144.54,0,0,1-4-17s-2.88-3.87-2.88-5.11c0-3.58,8.7-6.48,19.43-6.48s19.43,2.9,19.43,6.48Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M29.28-18c0,3.09-7.51,5.6-16.78,5.6S-4.29-14.88-4.29-18s7.52-5.59,16.79-5.59S29.28-21,29.28-18Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffc75a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.6-49c0-1.83-1.36-4.16-4.1-2.53-2.74-1.63-4.11.7-4.11,2.53A2,2,0,0,1,6-47.07s1.74,2.28,3.75.79a3.74,3.74,0,0,0,2.71,1.57,3.74,3.74,0,0,0,2.71-1.57c2,1.49,3.75-.79,3.75-.79A2,2,0,0,1,16.6-49Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffc75a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.91,86.54a1,1,0,0,1-.47-.11A1,1,0,0,1,6,85l5.59-11.18a1.05,1.05,0,0,1,1.88.94L7.85,86a1.06,1.06,0,0,1-.94.58Zm0,0",
    transform: "translate(194 123)",
    fill: "#b46446"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.09,86.54a1,1,0,0,1-.93-.58l-5.6-11.18A1.05,1.05,0,0,1,12,73.37a1,1,0,0,1,1.4.47L19,85a1,1,0,0,1-.47,1.41,1,1,0,0,1-.47.11Zm0,0",
    transform: "translate(194 123)",
    fill: "#b46446"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M37.67,76.75a115.19,115.19,0,0,1-50.33,0V65.93a115.49,115.49,0,0,0,50.33,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.2,72.68a115.49,115.49,0,0,1-32.58,1.61c.18,1.44,8.81,5.73,8.81,5.73S-30.18,83.7-30,85A115.28,115.28,0,0,0,1.2,83.69Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.84,72.68a115.54,115.54,0,0,0,32.59,1.61C56.24,75.73,47.61,80,47.61,80s7.62,3.68,7.44,5a115.28,115.28,0,0,1-31.21-1.34Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagSM;
exports["default"] = _default;